import { createSelector } from "@reduxjs/toolkit";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getEventEarningThunk, getAdminRevenueThunk as onGetAdminRevenueThunk } from "../../../slices/users/thunk";
import { getFileUrl } from "../../../utils/GetAuthUser";
import { Header } from "../../../components/header/Header";

const Earning = () => {
  const dispatch = useDispatch();
  const fileUrl = getFileUrl();
  const location = useLocation();

  // Check if URL contains 'artist'
  const isArtistPage = useMemo(() => {
    return location.pathname.toLowerCase().includes('artist');
  }, [location.pathname]);

  // Selector
  const selectUserState = (state) => state.user;
  const userSelector = createSelector(selectUserState, (user) => ({
    isLoading: user.isLoading,
    specialEventRevenue: Array.isArray(user.specialEventRevenue) 
      ? user.specialEventRevenue 
      : [],
//     specialEventRevenue:  [{
//             "id": 1,
//             "artistName": "Reffrel User",
//             "artistImage": "user-images/698a1b546faa8.jfif",
//             "userName": "Reffrel User",
//             "userImage": "user-images/698a1b546faa8.jfif",
//             "eventName": 'Sonata Art Event',
//             "eventImage": "event-images/698a2b7119924.jpg",
//             "amount": "20.00",
//             "discount": "0.00",
//             "actualAmount": "50.00"
//         }],
  }));

  const { isLoading, specialEventRevenue } = useSelector(userSelector);
  const { artistId } = useParams();

  // Fetch API data
  useEffect(() => {


    

    var data = {
      artist_id: artistId ?? null
    };
    // console.log("data");
    // console.log(data);
    

    dispatch(getEventEarningThunk(data));
  }, [dispatch]);

  // Helper function to safely render values
  const safeRender = (value, fallback = "N/A") => {
    if (value === null || value === undefined || value === "") {
      return fallback;
    }
    if (typeof value === "object") {
      return fallback;
    }
    return String(value);
  };

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title="Earnings" showBack={true} />
      </header>

      <div className="w-full xl:max-[70%] flex flex-col border border-border_color rounded-[14px] p-5 mt-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-lg sm:text-[22px] text-black font-bold font-grotesk">
            Earnings
          </span>
        </div>

        {/* Table */}
        <div className="overflow-x-auto overflow-y-auto" style={{ maxHeight: "calc(70vh - 100px)" }}>
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="border-b border-border_color">
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Sr No.
                </th>
                {!isArtistPage && (
                  <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                    Artist
                  </th>
                )}
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Event
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  User
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Actual Amount
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Discount
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Artist Earning
                </th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                // Skeleton rows
                Array.from({ length: 6 }).map((_, index) => (
                  <tr key={`skeleton-${index}`} className={(index + 1) % 2 === 0 ? "bg-[#2878870F]" : "bg-transparent"}>
                    <td className="px-3 py-3">
                      <div className={`h-7 w-7 rounded-lg ${(index + 1) % 2 === 0 ? "bg-white" : "bg-[#2878870F]"} animate-pulse`} />
                    </td>
                    {!isArtistPage && (
                      <td className="px-3 py-3">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
                          <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                      </td>
                    )}
                    <td className="px-3 py-3">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
                          <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                      </td>
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
                        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                      </div>
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-28 bg-gray-200 rounded animate-pulse" />
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-28 bg-gray-200 rounded animate-pulse" />
                    </td>
                  </tr>
                ))
              ) : specialEventRevenue && specialEventRevenue.length > 0 ? (
                specialEventRevenue.map((plan, index) => (
                  <tr
                    key={plan?.id || `row-${index}`}
                    className={(index + 1) % 2 === 0 ? "bg-[#2878870F]" : "bg-transparent"}
                  >
                    {/* Sr# */}
                    <td className="px-3 py-3 first:rounded-l-lg last:rounded-r-lg bg-transparent">
                      <div className={`h-7 w-7 rounded-lg flex items-center justify-center text-sm tracking-wider font-medium font-grotesk text-black ${(index + 1) % 2 === 0 ? "bg-white" : "bg-[#2878870F]"}`}>
                        {index + 1}
                      </div>
                    </td>
                    
                    {/* Artist - Only show if not on artist page */}
                    {!isArtistPage && (
                      <td className="px-3 py-3">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-200">
                            <img
                              src={
                                plan?.artistImage
                                  ? `${fileUrl}/${plan.artistImage}`
                                  : "/default-avatar.png"
                              }
                              alt="Artist"
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.src = "/default-avatar.png";
                              }}
                            />
                          </div>
                          <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                            {safeRender(plan?.artistName, "Unknown")}
                          </span>
                        </div>
                      </td>
                    )}

                    {/* Event Name */}
                    <td className="px-3 py-3">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-200">
                            <img
                              src={
                                plan?.eventImage
                                  ? `${fileUrl}/${plan.eventImage}`
                                  : "/default-avatar.png"
                              }
                              alt="Event"
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.src = "/default-avatar.png";
                              }}
                            />
                          </div>
                          <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                            {safeRender(plan?.eventName, "Unknown")}
                          </span>
                        </div>
                      </td>

                    {/* User with image */}
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-200">
                          <img
                            src={
                              plan?.userImage
                                ? `${fileUrl}/${plan.userImage}`
                                : "/default-avatar.png"
                            }
                            alt="User"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.src = "/default-avatar.png";
                            }}
                          />
                        </div>
                        <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                          {safeRender(plan?.userName, "Unknown")}
                        </span>
                      </div>
                    </td>

                    {/* Portal Fee */}
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black">
                      ${safeRender(plan?.actualAmount, "0.00")}
                    </td>

                    {/* Discount */}
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black">
                      ${safeRender(plan?.discount, "0.00")}
                    </td>
                    
                    {/* Artist Amount */}
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black">
                      ${safeRender(plan?.amount, "0.00")}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={isArtistPage ? "6" : "7"} className="py-6 text-center text-xl tracking-wider font-bold font-grotesk text-gray-500">
                    No Earnings Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Earning;